export default __webpack_public_path__ + "static/media/dieppe2.1182113f.jpg";